export const TRYING_GET_DATA = 'TRYING_GET_DATA';
export const TRYING_GET_DATA_SUCCESS = 'TRYING_GET_DATA_SUCCESS';
export const TRYING_GET_DATA_ERROR = 'TRYING_GET_DATA_ERROR';

export const TRYING_LOGIN_USER = 'TRYING_LOGIN_USER';
export const TRYING_LOGIN_USER_SUCCESS = 'TRYING_LOGIN_USER_SUCCESS';
export const TRYING_LOGIN_USER_ERROR = 'TRYING_LOGIN_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';